
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analyticsTracker';

interface PageTrackingLayoutProps {
  children: React.ReactNode;
}

const PageTrackingLayout: React.FC<PageTrackingLayoutProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    trackPageView({ pagePath: location.pathname });
  }, [location]);

  return (
    <>
      {children}
    </>
  );
};

export default PageTrackingLayout;
